<template>
    <div class="page-container">
        <div class="page-notice">提现审核成功后，将由您的客户经理联系您</div>
        <div class="page-content">
            <div class="section">
                <div class="section-title">收款账户</div>
                <div class="input-grp" style="border-bottom:1px solid #f0f0f0;">
                    <div class="name">收款账户</div>
                    <input type="text" v-model="accountName" placeholder="请输入收款账户名称">
                </div>
                <div class="input-grp">
                    <div class="name">收款账号</div>
                    <input type="text" v-model="accountNo" placeholder="请输入收款账号">
                </div>
            </div>
            <div class="section">
                <div class="section-title">提现金额 <span>(提现的金额需提供发票)</span></div>
                <div class="input-grp" style="justify-content:flex-start;">
                    <div style="color:#333;font-size:18px;">¥</div>
                    <input type="text" v-model="realAmount" style="font-size:30px;color:#333;text-align:left;margin-left:10px;background:transparent;" placeholder="请输入金额">
                </div>
                <div class="section-bottom">
                    可提现金额 ¥{{amount}}
                    <span>全部</span>
                </div>
            </div>
            <div class="btn-confirm" @click="confirm" v-if="accountName && accountNo && realAmount != 0">确认申请提现</div>
            <div class="btn-confirm disabled" v-else>确认申请提现</div>
        </div>
    </div>
</template>
<script>

import $http from '@/lib/request'
import config from '@/config'
import {Toast} from 'vant'

export default {
    data(){
        return {
            accountName:'',
            accountNo:'',
            realAmount:0,
            amount:0,
        }
    },
    components:{
        [Toast.name]:Toast
    },
    created(){
        this.amount=this.$route.params.amount;
    },
    methods:{
        confirm(){
            $http({
                method:'post',
                data:{
                    accountName:this.accountName,
                    accountNo:this.accountNo,
                    amount:this.realAmount
                },
                url:config.api.confirmWithdraw
            }).then(res=>{
                if(res.errno == 0){
                    let dataObj=new Date();
                    this.$router.push({
                        name:'withdraw-result',
                        params:{
                            accountName:this.accountName,
                            accountNo:this.accountNo,
                            amount:this.amount,
                            withdrawTime:dataObj.toLocaleDateString()
                        }
                    });
                }else{
                    Toast(res.errmsg);
                }
            })
        }
    }
}
</script>
<style lang="scss" scoped>
@mixin flex-between{
    display: flex;
    justify-content: space-between;
    align-items: center;
}
input::-webkit-input-placeholder{
    color: #999;
}
.page-container{
    min-height: 100vh;
    background:#f5f5f5;
    .page-notice{
        height:36px;
        line-height: 36px;
        background: #E6F1FF;
        padding:0 10px;
        font-size: 14px;
        color:#1671E1;
    }
    .page-content{
        padding:10px;
        .section{
            background:#fff;
            border-radius: 4px;
            padding:15px;
            padding-bottom: 0;
            margin-bottom: 10px;
            .section-title{
                color:#333;
                font-size: 15px;
                line-height: 21px;
                font-weight: 500;
                margin-bottom: 10px;
                &>span{
                    color:#999;
                    font-size: 13px;
                    margin-left: 5px;
                }
            }
            .input-grp{
                height:44px;
                @include flex-between();
                .name{
                    font-size: 14px;
                    color:#333;
                }
                &>input{
                    border:none;
                    text-align: right;
                }
            }
            .section-bottom{
                height:44px;
                line-height: 44px;
                font-size: 13px;
                color:#999;
                border-top:1px solid #f0f0f0;
                &>span{
                    color:#328DF7;
                    margin-left: 10px;
                }
            }
        }
        .btn-confirm{
            width: 180px;
            height: 40px;
            line-height: 40px;
            text-align: center;
            background: linear-gradient(90deg, #3088F5 0%, #3CA7FE 100%);
            border-radius: 26px;
            font-size: 16px;
            color:#fff;
            margin:0 auto;
            margin-top: 50px;
            &.disabled{
                background:#dcdcdc;
                color:#999;
            }
        }
    }
}
</style>